define('view/people/roles.list.component',['require','exports','module','uikit/uikit','backbone.radio','blockit'],function(require, exports, module) {
  //prettier-ignore
  var UIKit       = require('uikit/uikit'),
      Radio       = require('backbone.radio'),
      BlocKit     = require('blockit');

  var RolesListComponent = {
    type: BlocKit.AttachedComponentsContainerView,
    components: [
      {
        type: BlocKit.ContentActionsHeaderView,
        header: {
          text: 'Roles',
        },
      },
      {
        type: BlocKit.BasicTableView,
        model: '@resources.person',
        collection: '@resources.userGroups',
        emptyText: 'No assigned roles',
        selectable: true,
        columns: [
          { text: 'Name', data: 'groupGroupName', sortable: false }, // TODO: should be sortable: true, but endpoint doesn't currently support sort requests
        ],
      },
    ],
  };

  module.exports = RolesListComponent;
});

